import { urlTransform } from 'utils/formHelpers'

const formatSchedulePayload = (session, formValues) => {
  const {
    startTime,
    endTime,
    sessionNotes,
    sessionUrl
  } = formValues;

  const payload = {
      type: session.type,
      id: session.id,
      attributes: {
        session_url: urlTransform(sessionUrl) || null,
        start_time: startTime || null,
        end_time: endTime || null,
        notes: sessionNotes || null,
        teamName: session.teamName || null,
      }

  }

  return payload;

}

export default formatSchedulePayload